'use client';

import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import {ReactNode} from "react";

export default function ReCaptchaContext({children, reCaptchaKey}: { children: ReactNode, reCaptchaKey: string }) {
    return <GoogleReCaptchaProvider
        reCaptchaKey={reCaptchaKey}>{children}</GoogleReCaptchaProvider>;
}